export default __webpack_public_path__ + "static/media/contact.8daa726f.mp4";